import { Button, MenuItem } from '@blueprintjs/core';
import { Select2 } from '@blueprintjs/select';
import React from 'react';

import { useAppDispatch, useAppSelector } from 'hooks';
import {
  allRoutesSelector,
  removeSelectedRoute,
  selectRoute,
} from 'store/scoring';

import styles from './Scoring.module.scss';

export default function RouteSelector({
  routeIndex,
  canRemove,
}: {
  routeIndex: number;
  canRemove: boolean;
}) {
  const allRoutes = useAppSelector(allRoutesSelector);
  const selectedCategory = useAppSelector(
    (state) => state.scoring.selectedRouteCategory
  );
  const selectedRoute = useAppSelector(
    (state) => state.scoring.selectedRoutes[selectedCategory]?.[routeIndex]
  );

  const dispatch = useAppDispatch();

  return (
    <div className={styles.routeSelector}>
      <Select2
        inputProps={{ className: styles.input, type: 'number' }}
        items={allRoutes}
        itemPredicate={(query, route) => String(route).includes(query)}
        onItemSelect={() => {}}
        itemRenderer={(route) => (
          <MenuItem
            active={selectedRoute === route}
            text={`Route #${route}`}
            onClick={() => dispatch(selectRoute({ route, routeIndex }))}
            key={route}
          />
        )}
      >
        <Button
          outlined
          text={selectedRoute ? `Route #${selectedRoute}` : 'Select route'}
          className={styles.routeSelectorButton}
          rightIcon="double-caret-vertical"
        />
        {canRemove && (
          <Button
            onClick={() => dispatch(removeSelectedRoute(routeIndex))}
            icon="trash"
            className={styles.removeRouteButton}
          />
        )}
      </Select2>
    </div>
  );
}
